import { Box } from '@mantine/core';
import { useParams } from 'react-router-dom';

import { useGetProphetPage } from '../api/getPage';
import { PageAudit } from '../components/Pages/PageAudit';
import { Rules } from '../components/Rules/Rules';
import { Stats } from '../components/Stats/Stats';

import { SectionDivider } from '@/components/Layout/SectionDivider';
import { UrlPlatform, urlToDomainPlatform } from '@/features/pages';

type Props = {
  platform: UrlPlatform;
};

export const ProphetPage = ({ platform }: Props) => {
  const { id = '' } = useParams<{ id: string }>();
  const chunkPlatform = urlToDomainPlatform(platform);

  // Funnel names live on the app page — resolve appPage._id through the
  // prophet page (the id in the URL is prophet.pages._id). A dedicated
  // endpoint (not the department listing) so direct links work regardless
  // of the department selected in the store.
  const { data } = useGetProphetPage({ pageId: id });
  const appPageId = data?.page.appPage._id ?? '';

  return (
    <div>
      <SectionDivider label="Rules" />
      <Rules pageId={id} platform={chunkPlatform} />
      <SectionDivider label="Stats" />
      <Stats pageId={id} />
      <Box mt="xl">
        <SectionDivider label="История изменений" />
        <PageAudit pageId={id} appPageId={appPageId} />
      </Box>
    </div>
  );
};
